import { Check, Clock, Shield, Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const benefits = [
  {
    title: "Pre-vetted Talent",
    description: "Only top 1% of developers pass our rigorous screening process",
    icon: Star,
  },
  {
    title: "Risk-Free Trial",
    description: "Work with developers for a trial period to ensure perfect fit",
    icon: Shield,
  },
  {
    title: "Quick Matching",
    description: "Get matched with the right developer within 48 hours",
    icon: Clock,
  },
  {
    title: "Verified Skills",
    description: "All developers are tested for technical and soft skills",
    icon: Check,
  },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-primary mb-4">
            Why Choose Our Developers
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            We connect you with exceptional developers who have proven their
            expertise through our comprehensive vetting process.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit) => (
            <Card key={benefit.title} className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300">
              <CardContent className="pt-6">
                <div className="flex flex-col items-center text-center">
                  <div className="p-3 bg-secondary/10 rounded-full mb-4">
                    <benefit.icon className="h-6 w-6 text-secondary" />
                  </div>
                  <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};